<body>
  <section class="banner">
    <div class="site-header">
      <div class="container-fluid">
        <div class="row justify-content-between align-items-center">
          <div class="col-lg-3 col-sm-4">
            <div class="logo">
              <img
                src="{{ onPassiveBaseUrl }}onpassive(fav-10)/images/logo.png"
                alt="logo"
                class="img-fluid"
              />
            </div>
          </div>
          <div class="col-lg-5 col-sm-6">
            <div class="social-icon text-center text-sm-right text-lg-center">
              <ul class="pl-0">
                <li>
                  <a
                    href="https://onpassive.com/blog"
                    target="_blank"
                    rel="noopener"
                    class="icons"
                    ><img
                      src="{{
                        onPassiveBaseUrl
                      }}onpassive(fav-10)/images/s1.png"
                      alt="s1"
                      class="img-fluid"
                  /></a>
                </li>
                <li>
                  <a
                    href="https://www.facebook.com/ONPASSIVE/ONPASSIVE"
                    target="_blank"
                    rel="noopener"
                    class="icons"
                    ><img
                      src="{{
                        onPassiveBaseUrl
                      }}onpassive(fav-10)/images/s2.png"
                      alt="s2"
                      class="img-fluid"
                  /></a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/ONPASSIVE/"
                    target="_blank"
                    rel="noopener"
                    class="icons"
                    ><img
                      src="{{
                        onPassiveBaseUrl
                      }}onpassive(fav-10)/images/s3.png"
                      alt="s3"
                      class="img-fluid"
                  /></a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/c/ONPASSIVEc/ONPASSIVE"
                    target="_blank"
                    rel="noopener"
                    class="icons"
                    ><img
                      src="{{
                        onPassiveBaseUrl
                      }}onpassive(fav-10)/images/s4.png"
                      alt="s4"
                      class="img-fluid"
                  /></a>
                </li>
                <li>
                  <a
                    href="https://twitter.com/ONPASSIVE"
                    target="_blank"
                    rel="noopener"
                    class="icons"
                    ><img
                      src="{{
                        onPassiveBaseUrl
                      }}onpassive(fav-10)/images/s5.png"
                      alt="s5"
                      class="img-fluid"
                  /></a>
                </li>
                <li>
                  <a
                    href="https://www.linkedin.com/company/onpassiveofficial/company/onpassiveofficial"
                    target="_blank"
                    rel="noopener"
                    class="icons"
                    ><img
                      src="{{
                        onPassiveBaseUrl
                      }}onpassive(fav-10)/images/s6.png"
                      alt="s6"
                      class="img-fluid"
                  /></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-8">
          <div class="banner-text">
            <h2>launching soon</h2>
            <h4>Experience the World of Automation</h4>
            <p>
              Maximize your business potential with less effort and more impact.
              Our mission is to unlock new ways for people to launch their
              business in the places they care about. A system that is fully
              automated can reduce all your efforts in building a successful
              business and reach your goals. If you are eager to build your own
              fortune, be the one who decides to go for it.
            </p>
            <a
              href="/registration/user?reg={{ userId }}"
              name="regform"
              target="_blank"
              rel="noopener"
              class="btn btn-primary text-uppercase mt-3"
            >
              Become A Founder now <i class="fa fa-angle-right"></i>
            </a>
          </div>
        </div>

        <div class="col-sm-5 human-robot">
          <img
            src="{{ onPassiveBaseUrl }}onpassive(fav-10)/images/human-robot.png"
            alt="human-robot"
            class="img-fluid"
          />
        </div>
      </div>
    </div>
    <div class="clouds">
      <img
        src="{{ onPassiveBaseUrl }}onpassive(fav-10)/images/cloud.png"
        alt="cloud"
        class="w-100"
      />
    </div>
  </section>
  <section class="store">
    <div class="container-fluid">
      <h2 class="text-center heading">
        world class <br />
        <strong> business tools</strong>
      </h2>
      <div class="row align-items-center mb-3">
        <div class="col-lg-4">
          <div class="store-thumb">
            <img
              src="{{ onPassiveBaseUrl }}onpassive(fav-10)/images/store1.png"
              alt="store1"
              class="img-fluid"
            />
          </div>
        </div>
        <div class="col-lg-8">
          <div class="store-content">
            <p>
              Reduce manual work and induce automation to your business to get
              your business matters in order. Outsmart the issues raising the
              world of business with the help of automation. ONPASSIVE allows
              businesses to attract and retain customers by enabling effortless,
              personalized automation experiences.
            </p>
          </div>
        </div>
      </div>
      <div class="row align-items-center mb-4">
        <div class="col-lg-4 order-1 order-lg-2">
          <div class="store-thumb">
            <img
              src="{{ onPassiveBaseUrl }}onpassive(fav-10)/images/store2.png"
              alt="store2"
              class="img-fluid"
            />
          </div>
        </div>
        <div class="col-lg-8 order-2 order-lg-1">
          <div class="store-content">
            <p>
              With ONPASSIVE, improve your potential for expansion and growth.
              Get your business to grow both locally and globally, offline and
              online, ONPASSIVE business solutions uphold all your business
              goals. Global expansion can be tricky but with the help of
              Artificial Intelligence, we can help you boost your chances of
              expansion.
            </p>
          </div>
        </div>
      </div>
      <div class="row align-items-center">
        <div class="col-lg-4">
          <div class="store-thumb">
            <img
              src="{{ onPassiveBaseUrl }}onpassive(fav-10)/images/store3.png"
              alt="store3"
              class="img-fluid"
            />
          </div>
        </div>
        <div class="col-lg-8">
          <div class="store-content">
            <p>
              Redefine customer engagement and acquisition with AI tools at your
              fingertips. Unravel complex business issues and over time and
              across channels to identify new opportunities. Transform insights
              into digital initiatives with our AI-driven tools. Help your
              customers understand your business and provide what they are
              exactly looking for with the insights we provide.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="feature-video text-center">
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-lg-10">
          <h2 class="heading">
            The inspiration you seek is already within you. <br />
            <strong>Fuel it with ONPASSIVE.</strong>
          </h2>
          <p>
            ONPASSIVE caters proficient business solutions by amplifying human
            intelligence with the help of artificial intelligence. Drive your
            business forward with us and present your business globally.
            Leverage on analytical insights and set your business on autopilot
            mode.
          </p>
        </div>
      </div>
      <div class="row justify-content-center video-bg" id="onpassive">
        <div class="col-lg-9">
          <div class="video_box acc_panel">
            <video
              id="my-video"
              class="video-js video-size w-100 h-auto"
              controls
              preload="auto"
              poster="{{ onPassiveBaseUrl }}onpassive(jan-23)/images/poster.png"
              data-setup="{}"
            >
              <source
                src="{{
                  myLinksS3URL
                }}videos/Onpassive_launching_page_video2.mp4"
                type="video/mp4"
              />
            </video>
          </div>
        </div>
      </div>
      <a
        href="/registration/user?reg={{ userId }}"
        target="_blank"
        rel="noopener"
        class="btn btn-primary text-uppercase"
      >
        Join us now <i class="fa fa-angle-right"></i>
      </a>
    </div>
  </section>
  <footer class="main-footer text-center">
    <div class="container-fluid">
      <h3>
        Millions of people are waiting for you to create the future.
        <strong> What are you waiting for? </strong>
      </h3>
    </div>
    <div class="clouds">
      <img
        src="{{ onPassiveBaseUrl }}onpassive(fav-10)/images/cloud.png"
        alt="cloud"
        class="w-100"
      />
    </div>
  </footer>
</body>
